import Section from '../../views/layout/Section'
import Main from '../../views/layout/Main'

export const LoginSection = Section.extend`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  flex-grow: 1;
  position: relative;
`

export const LoginMain = Main.extend`
  display: flex;
  align-items: center;
  justify-content: center;
`



// WEBPACK FOOTER //
// ./src/components/templates/login/LoginLayout.js